const actions = {
    GET_DETAILS_REQUEST: 'GET_DETAILS_REQUEST',
    GET_DETAILS_SUCCESS: 'GET_DETAILS_SUCCESS',
    GET_DETAILS_ERROR: 'GET_DETAILS_ERROR',
    getDetails: (url) => ({
      type: actions.GET_DETAILS_REQUEST,
      payload: { url },
    }),
  };
  
  export default actions;
  